var React = require('react');

function ArrowUndoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5012 13.753V10.7524C11.1395 10.7524 12.4832 11.8076 14.0026 13.753C14.0026 10.0263 12.7658 6.25139 7.5012 6.25139V3.25073L2 8.50188L7.5012 13.753Z","stroke":"#232427","strokeWidth":"1.00189","strokeLinejoin":"round"}));
}

ArrowUndoInline.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowUndoInline;

ArrowUndoInline.default = ArrowUndoInline;
